import { __rest } from "tslib";
import React from 'react';
import { PARAM_KEY } from './constants';
import { makeDecorator } from '@storybook/preview-api';
export const withApolloClient = makeDecorator({
    name: 'withApolloClient',
    parameterName: PARAM_KEY,
    wrapper: (storyFn, context, { parameters }) => {
        const { MockedProvider } = parameters, providerProps = __rest(parameters, ["MockedProvider"]);
        if (!MockedProvider) {
            console.warn('storybook-addon-apollo-client: MockedProvider is missing from parameters in preview.js');
            return storyFn(context);
        }
        return React.createElement(MockedProvider, Object.assign({}, providerProps), storyFn(context));
    }
});
//# sourceMappingURL=decorators.js.map